module.exports = __webpack_public_path__ + "static/media/bathtub.393feb77.svg";